import { useEffect, useState } from 'react';
import { logError } from 'utils/logger';
import { Invoice } from 'modules/invoice';
import { useLazyQuery } from '@apollo/client';
import { isNullOrUndefined } from 'utils/typeGuargs';

import { lenderDeskingApi } from './index';
import { lenderDeskingPanelMapper } from '../mappers';
import { collectFinanceVariablesForCalc } from '../../../desking/lib';

export function useCalculate(program: any, cs: any, invoice: Invoice) {
  const [financePricing, setFinancePricing] = useState<Record<string, any>>({});

  const [onCalculate, { loading: isCalculating, previousData }] = useLazyQuery(lenderDeskingApi.calculate);

  useEffect(() => {
    const isSkipCalculate = !program.amount || !program.terms.length;

    if (isSkipCalculate) return;

    const saleDetails = lenderDeskingPanelMapper.processSaleDetails(invoice);

    // TODO create own mapper
    onCalculate({
      variables: collectFinanceVariablesForCalc({
        program: program as any,
        saleDetails,
        proposalMenu: null,
        financeProgramDescription: '',
        isExcludeEquipmentSales: false,
        proposalProductConfigurationsInMenu: {},
        submission: { selectedSubmissionId: cs?.creditSubmissionId, maxApprovalAmount: cs?.approvedAmount ?? 0 },
      }),
    })
      .then(response => {
        const optionsData = response?.data?.calculateMultiplePayments?.[0]?.paymentOptions;
        const prevOptionsData = previousData?.calculateMultiplePayments?.[0]?.paymentOptions;
        setFinancePricing(normalizePaymentsByTerm(optionsData ?? prevOptionsData));
      })
      .catch(logError);
  }, [cs, program, onCalculate, previousData?.calculateMultiplePayments, invoice]);

  return { isCalculating, financePricing, setFinancePricing };
}

function normalizePaymentsByTerm(options: any[] | null | undefined): Record<string, any> {
  if (isNullOrUndefined(options)) return {};

  return options.reduce((acc, payment) => {
    acc[payment.term] = payment;
    return acc;
  }, {});
}
